"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyMoment = void 0;

var _react = _interopRequireWildcard(require("react"));

var _atoms = require("../../atoms");

var _helpers = require("../../util/helpers");

var _tags = require("../../util/tags");

var _index = require("../../index");

require("./MyMoment.css");

var _excluded = ["theKey", "index", "moment", "userID", "utmCampaign", "onClickMoment", "onAddToTraceiDClick", "onShareClick", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Vars
var visibleMoments = []; // My Moment

var MyMoment = function MyMoment(_ref) {
  var _massagedMoment$meta;

  var theKey = _ref.theKey,
      index = _ref.index,
      moment = _ref.moment,
      userID = _ref.userID,
      utmCampaign = _ref.utmCampaign,
      onClickMoment = _ref.onClickMoment,
      onAddToTraceiDClick = _ref.onAddToTraceiDClick,
      onShareClick = _ref.onShareClick,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var cn = className ? "MyMoment ".concat(className) : "MyMoment"; // Some vars we'll need

  var timeout = 0;
  var childRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showInfo = _useState2[0],
      setShowInfo = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isAnyDropdownOpen = _useState4[0],
      setIsAnyDropdownOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      playing = _useState6[0],
      setPlaying = _useState6[1];

  var formatTime = function formatTime(time) {
    var formattedTime = "";

    if (time) {
      var m = 0;
      var s = 0;
      var total = time;
      m = Math.floor(total / 60);
      total = total - m * 60;
      s = Math.floor(total);

      if (s < 10) {
        s = "0".concat(s);
      }

      formattedTime = "".concat(m, ":").concat(s);
    }

    return formattedTime;
  };

  (0, _react.useEffect)(function () {
    if (!isAnyDropdownOpen) {
      setShowInfo(false);
    }
  }, [isAnyDropdownOpen]);

  var _onMouseEnter = function onMouseEnter(e) {
    childRef.current.play();
    setShowInfo(true);
  };

  var _onMouseLeave = function onMouseLeave(e) {
    childRef.current.stop();
    setShowInfo(false);
  };
  /**
   * Do video auto playback on visibility of the video preview
   * If the preview is fully visible we start playing the video
   * If more than one preview is fully visible we start the first
   * full one in the list.
   * @param e
   */


  var onVisibilityChange = function onVisibilityChange(e) {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (!(0, _helpers.isScreenWidthLessThan)(680)) return;

      if (e.event.intersectionRatio === 1 && e.action === "show") {
        visibleMoments.push(e);
      } else {
        if (e.isCurrentlyPlaying) e.video.pause();
        visibleMoments = visibleMoments.filter(function (item) {
          return item.index !== e.index;
        });
      }

      visibleMoments.sort(function (a, b) {
        return a.index - b.index;
      });
      visibleMoments.forEach(function (item, index) {
        if (index === 0) {
          var _visibleMoments$index;

          if ((_visibleMoments$index = visibleMoments[index]) !== null && _visibleMoments$index !== void 0 && _visibleMoments$index.video) visibleMoments[index].video.play();
        } else {
          var _visibleMoments$index2;

          if ((_visibleMoments$index2 = visibleMoments[index]) !== null && _visibleMoments$index2 !== void 0 && _visibleMoments$index2.video) visibleMoments[index].video.pause();
        }
      });
    }, 500);
  }; // Formatting text


  var formattedTime = moment ? formatTime(moment.dynamic_start) : null;
  var massagedMoment = moment && !moment.home_team.id ? {
    dynamic_hls: moment.dynamic_hls,
    game_id: moment.game_id,
    game_clip_id: moment.game_clip_id,
    meta: _objectSpread(_objectSpread({}, moment), {}, {
      home_team: _objectSpread(_objectSpread({}, moment.home_team), {}, {
        id: moment.home_team.name
      })
    })
  } : moment;

  var addToTraceiDClick = function addToTraceiDClick(e) {
    if (typeof onAddToTraceiDClick === "function") {
      (0, _index.trackEvent)({
        action: "Add to Trace iD Pressed",
        element: e.currentTarget
      });
      onAddToTraceiDClick(e, moment);
    }
  };

  var shareClick = function shareClick(e) {
    if (typeof onShareClick === "function") {
      (0, _index.trackEvent)({
        action: "Share Button Pressed",
        element: e.currentTarget
      });
      onShareClick(e, moment);
    }
  }; // In traceiD?


  var traceiDIcon = moment !== null && moment !== void 0 && moment.parent_col_id ? _index.Icon.Type.TraceIDFilled : _index.Icon.Type.TraceIDEmpty;
  var traceiDIconColor = moment !== null && moment !== void 0 && moment.parent_col_id ? _atoms.Color.Trace : _atoms.Color.Grey4; // Combine the parent event with its sources into a single list

  var allMomentSources = massagedMoment !== null && massagedMoment !== void 0 && (_massagedMoment$meta = massagedMoment.meta) !== null && _massagedMoment$meta !== void 0 && _massagedMoment$meta.sources ? [massagedMoment].concat(_toConsumableArray(massagedMoment.meta.sources)) : [massagedMoment]; // Moment Preview controls

  var changeLoopCount = function changeLoopCount(loopCount) {
    var allMomentSourcesLength = allMomentSources ? allMomentSources.length : 1;
    var maxLoopCount = allMomentSourcesLength * 5;

    if (loopCount > maxLoopCount) {
      console.log("Call stop() on MomentPreview b/c we have exceed max loop count of ".concat(maxLoopCount, " for ").concat(allMomentSources, " sources"));
      childRef.current.stop();
    }
  }; // Return


  return /*#__PURE__*/_react.default.createElement(_index.Column, _extends({
    key: theKey,
    trkContext: "My Moment",
    touchable: true,
    className: cn,
    onClick: function onClick() {
      onClickMoment(moment);
    },
    onMouseEnter: function onMouseEnter(e) {
      return !isAnyDropdownOpen && _onMouseEnter(e);
    },
    onMouseLeave: function onMouseLeave(e) {
      return !isAnyDropdownOpen && _onMouseLeave(e);
    }
  }, props), moment && /*#__PURE__*/_react.default.createElement(_index.MomentPreview, {
    key: theKey,
    ref: childRef,
    rootMargin: "-134px 0px 0px 0px",
    event: massagedMoment,
    sources: allMomentSources,
    utmCampaign: utmCampaign,
    userId: userID,
    changeLoopCount: changeLoopCount,
    onVisibilityChange: onVisibilityChange,
    index: index,
    autoPlay: true,
    imageCover: true,
    noHoverPlay: true,
    showProgressBar: showInfo,
    trackingAction: "My Moments",
    trackingPlayerType: "mini",
    isMomentPlaying: function isMomentPlaying(playing) {
      return setPlaying(playing);
    }
  }), /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "header",
    justifyContent: "space-between",
    background: _atoms.Color.White2,
    alignItems: "center",
    padding: "4 5"
  }, /*#__PURE__*/_react.default.createElement(_index.Label, {
    className: "time",
    bold: true,
    marginRight: 4
  }, formattedTime), /*#__PURE__*/_react.default.createElement(_index.Row, {
    className: "tags",
    justifyContent: "flex-start"
  }, moment && /*#__PURE__*/_react.default.createElement(_index.MomentTags, {
    tags: (0, _index.generateHumanTags)(moment)
  }), /*#__PURE__*/_react.default.createElement(_index.Element, {
    className: "tags-mask"
  })), /*#__PURE__*/_react.default.createElement(_index.RoundButton, {
    className: "momentShareButton",
    iconColor: _atoms.Color.Black,
    iconSize: 18,
    icon: _index.Icon.Type.Action,
    onClick: shareClick,
    marginRight: "1"
  }), /*#__PURE__*/_react.default.createElement(_index.Button, {
    primary: true,
    content: "Save",
    width: "66px",
    height: "36px",
    onClick: addToTraceiDClick
  })));
};

exports.MyMoment = MyMoment;
MyMoment.defaultProps = {
  utmCampaign: "utmCampaign"
};